// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.00001 2H8V4H16L16 2H22V8H20V16H22V22H16L16 20H8V22H2V16H4V8H2L2.00001 2ZM6 8V16H8V18H16L16 16H18V8H16L16 6H8V8H6Z"}}]};

const Transform1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'transform-1-filled',
    ref,
    icon: element,
  },
));

Transform1FilledIcon.displayName = 'Transform1FilledIcon';

export default Transform1FilledIcon;
